import * as React from 'react';


export default function useSnippet() {
  React.useEffect(() => {
    const snippet = document.createElement('script');
    // @ts-expect-error - TS7034 - Variable 'widgetIframe' implicitly has type 'any' in some locations where its type cannot be determined. | TS7034 - Variable 'widgetButtonIframe' implicitly has type 'any' in some locations where its type cannot be determined.
    let widgetIframe, widgetButtonIframe;

    // snippet.src = 'https://multientity.dserver.com/snippet.js';
    // snippet.src = 'https://multientity.stage-chatbot-06.sensehq.co/snippet.js';
    // snippet.src = 'https://multientity.sandbox-preprod.sensehq.com/snippet.js';
    snippet.src =
      'https://sales-journeys-demo.sensehq.com/snippet.js?bottom=40';
    snippet.async = true;
    snippet.onload = () => {
      widgetIframe = document.getElementById('__sense-widget');
      widgetButtonIframe = document.getElementById('__sense-widget-button');
    };

    document.body?.appendChild(snippet);

    return () => {
      if (document.body == null) {
        return;
      }
      document.body.removeChild(snippet);
      // @ts-expect-error - TS7005 - Variable 'widgetIframe' implicitly has an 'any' type.
      if (widgetIframe) {
        document.body?.removeChild(widgetIframe);
      }
      // @ts-expect-error - TS7005 - Variable 'widgetButtonIframe' implicitly has an 'any' type.
      if (widgetButtonIframe) {
        document.body?.removeChild(widgetButtonIframe);
      }
    };
  }, []);
}
